module.exports = __webpack_public_path__ + "static/media/pharmacy_shop.4f1db2af.jpg";